import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import { SnackbarProvider } from "./Components/Snackbar/SnackBarContext";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import store from "./StateManagement/store";
import { Toaster } from "react-hot-toast";
import OfflineNotifier from "./FrontEnd/components/offlineNotfier";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./StateManagement/authContext";
import { ThemeContextProvider } from "./StateManagement/themeContext";
import { NotificationProvider } from "./StateManagement/notificationContext";
import { DashboardProvider } from "./StateManagement/dashboardContext";

const initialOptions = {
  clientId: "sb-8z5bb3685001@personal.example.com", // Replace with your PayPal Client ID
  currency: "INR" // Set your desired currency
};

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );

ReactDOM.render(
  <Provider store={store}>
    <ThemeContextProvider>
      <NotificationProvider>
        <Toaster position="top-center" />
        <OfflineNotifier />
        <SnackbarProvider>
          <AuthProvider>
            <DashboardProvider>
              <BrowserRouter >
                <App />
              </BrowserRouter>
            </DashboardProvider>
          </AuthProvider>
        </SnackbarProvider>
      </NotificationProvider>
    </ThemeContextProvider>
  </Provider>,
  document.getElementById("root")
);


reportWebVitals();
